import { RouteObject } from "react-router";

const routes: RouteObject = {
    path: '/blog/posts',

    children: [
        {
            path: 'create',
            handle: { layout: 'full' },
            lazy: {
                Component: async () => (
                    (await import('./Form')).default
                ),
            },
        },

        {
            path: ':postId/edit',
            handle: { layout: 'full' },
            lazy: {
                loader: async () => (
                    (await import('./Form')).loader
                ),

                Component: async () => (
                    (await import('./Form')).default
                ),
            },
        },
    ]
};

const indexPostTypes = [
    '',
    'draft',
    'published',
    'trashed',
];

indexPostTypes.map((indexPostType) => {
    if (typeof routes.children === 'undefined') {
        routes.children = [];
    }

    routes.children.push({
        path: indexPostType,
        lazy: {
            loader: async () => {
                const { loader } = await import("./Index");

                return () => loader(indexPostType);
            },

            Component: async () => (
                (await import('./Index')).default
            ),
        },
    });
});

export default routes;
